import { useState } from 'react';

const useSingleFormPage = ({ inputValue, validator, onChange, onSubmit }) => {
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);

  const _onSubmit = () => {
    setShowErrorMessage(true);

    const _errorMessage = validator(inputValue);

    if (!_errorMessage) onSubmit();
    else setErrorMessage(_errorMessage);
  };

  const _onChange = (value) => {
    onChange(value);
    if (showErrorMessage) setErrorMessage(validator(value));
  };

  return {
    errorMessage: showErrorMessage ? errorMessage : '',
    onSubmit: _onSubmit,
    onChange: _onChange,
  };
};

export default useSingleFormPage;
